import { createI18n } from 'vue-i18n'

import enGlobal from '@/modules/global/locales/en.json'
import itGlobal from '@/modules/global/locales/it.json'
import enAuth from '@/modules/auth/locales/en.json'
import itAuth from '@/modules/auth/locales/it.json'
import enDashboard from '@/modules/dashboard/locales/en.json'
import itDashboard from '@/modules/dashboard/locales/it.json'
import enExcessInventory from '@/modules/excess-inventory/locales/en.json'
import itExcessInventory from '@/modules/excess-inventory/locales/it.json'
import enCircularSolutions from '@/modules/circular-solutions/locales/en.json'
import itCircularSolutions from '@/modules/circular-solutions/locales/it.json'
import enProjects from '@/modules/projects/locales/en.json'
import itProjects from '@/modules/projects/locales/it.json'
import enCompanyProfile from '@/modules/company-profile/locales/en.json'
import itCompanyProfile from '@/modules/company-profile/locales/it.json'
import enDocuments from '@/modules/documents/locales/en.json'
import itDocuments from '@/modules/documents/locales/it.json'
import enProcesses from '@/modules/processes/locales/en.json'
import itProcesses from '@/modules/processes/locales/it.json'
import enLocations from '@/modules/locations/locales/en.json'
import itLocations from '@/modules/locations/locales/it.json'
import enSettings from '@/modules/settings/locales/en.json'
import itSettings from '@/modules/settings/locales/it.json'
import enOrders from '@/modules/orders/locales/en.json'
import itOrders from '@/modules/orders/locales/it.json'
import enPartners from '@/modules/partners/locales/en.json'
import itPartners from '@/modules/partners/locales/it.json'
import enQuotations from '@/modules/quotations/locales/en.json'
import itQuotations from '@/modules/quotations/locales/it.json'
import enInbox from '@/modules/inbox/locales/en.json'
import itInbox from '@/modules/inbox/locales/it.json'
import enBatchImport from '@/modules/batch-import/locales/en.json'
import itBatchImport from '@/modules/batch-import/locales/it.json'
import enFeedstock from '@/modules/feedstock/locales/en.json'
import itFeedstock from '@/modules/feedstock/locales/it.json'

// Key must be the same as module name in "modules" folder
type Schema = {
  global: typeof enGlobal
  auth: typeof enAuth
  dashboard: typeof enDashboard
  'excess-inventory': typeof enExcessInventory
  'circular-solutions': typeof enCircularSolutions
  projects: typeof enProjects
  'company-profile': typeof enCompanyProfile
  documents: typeof enDocuments
  processes: typeof enProcesses
  locations: typeof enLocations
  settings: typeof enSettings
  orders: typeof enOrders
  partners: typeof enPartners
  quotations: typeof enQuotations
  inbox: typeof enInbox
  'batch-import': typeof enBatchImport
  feedstock: typeof enFeedstock
}

export type AppLocale = 'en' | 'it'

export const i18n = createI18n<[Schema], AppLocale, false>({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      global: enGlobal,
      auth: enAuth,
      dashboard: enDashboard,
      'excess-inventory': enExcessInventory,
      'circular-solutions': enCircularSolutions,
      projects: enProjects,
      'company-profile': enCompanyProfile,
      documents: enDocuments,
      processes: enProcesses,
      locations: enLocations,
      settings: enSettings,
      orders: enOrders,
      partners: enPartners,
      quotations: enQuotations,
      inbox: enInbox,
      'batch-import': enBatchImport,
      feedstock: enFeedstock,
    },
    it: {
      global: itGlobal,
      auth: itAuth,
      dashboard: itDashboard,
      'excess-inventory': itExcessInventory,
      'circular-solutions': itCircularSolutions,
      projects: itProjects,
      'company-profile': itCompanyProfile,
      documents: itDocuments,
      processes: itProcesses,
      locations: itLocations,
      settings: itSettings,
      orders: itOrders,
      partners: itPartners,
      quotations: itQuotations,
      inbox: itInbox,
      'batch-import': itBatchImport,
      feedstock: itFeedstock,
    },
  },
})
